

export const mutations = {
  LOAD_CATEGORY_LIST(state, categoryList) {
    state.categoryList = categoryList
  },
  DELETE_CATEGORY(state, category) {
    state.categoryList = state.categoryList.filter(
      (activeCategory) => activeCategory.id !== category.id
    )
  },
  SET_SELECTED_CATEGORY(state, category) {
    state.selectedCategory = category
    if (!category) {
      state.categoryListExcludingSelectedCategory = state.categoryList
      return
    }
    // exclude selected category from list
    state.categoryListExcludingSelectedCategory = state.categoryList.filter((activeCategory) => activeCategory.id !== category.id)
  },
  LOAD_UOM_LIST(state, uomList) {
    state.uomList = uomList
  },
  DELETE_UOM(state, uom) {
    state.uomList = state.uomList.filter(
      (activeUom) => activeUom.id !== uom.id
    )
  },
  SET_SELECTED_UOM(state, uom) {
    state.selectedUom = uom
  },
  LOAD_CATEGORY_GROUPS_LIST(state, categoryGroupsList) {
    state.categoryGroupsList = categoryGroupsList
  },
  DELETE_CATEGORY_GROUPS(state, categoryGroups) {
    state.categoryGroupsList = state.categoryGroupsList.filter(
      (activeCategoryGroups) => activeCategoryGroups.id !== categoryGroups.id
    )
  },
  SET_SELECTED_CATEGORY_GROUPS(state, categoryGroup) {
    state.selectedCategoryGroups = categoryGroup
  },
  LOAD_TEMPLATES_LIST(state, templatesList) {
    state.templatesList = templatesList
  },
  SET_SELECTED_TEMPLATE(state, template) {
    state.selectedTemplate = template
  },
  DELETE_TEMPLATE(state, template) {
    state.templatesList = state.templatesList.filter(
      (activeTemplates) => activeTemplates.id !== template.id
    )
  },
}
